function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module link/ui/linkactionsview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
import ViewCollection from '@ckeditor/ckeditor5-ui/src/viewcollection';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '@ckeditor/ckeditor5-ui/src/focuscycler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import { ensureSafeUrl } from '../utils';
import unlinkIcon from '../../theme/icons/unlink.svg';
import pencilIcon from '@ckeditor/ckeditor5-core/theme/icons/pencil.svg';
import '../../theme/linkactions.css';
/**
 * The link actions view class. This view displays the link preview, allows
 * unlinking or editing the link.
 *
 * @extends module:ui/view~View
 */
var LinkActionsView = /*#__PURE__*/
function (_View) {
    _inherits(LinkActionsView, _View);
    var _super = _createSuper(LinkActionsView);
    /**
   * @inheritDoc
   */
    function LinkActionsView(locale) {
        var _this;
        _classCallCheck(this, LinkActionsView);
        _this = _super.call(this, locale);
        var t = locale.t;
        /**
     * Tracks information about DOM focus in the actions.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        _this.focusTracker = new FocusTracker();
        /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */
        _this.keystrokes = new KeystrokeHandler();
        /**
     * The href preview view.
     *
     * @member {module:ui/view~View}
     */
        _this.previewButtonView = _this._createPreviewButton();
        /**
     * The unlink button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */
        _this.unlinkButtonView = _this._createButton(t('Unlink'), unlinkIcon, 'unlink');
        /**
     * The edit link button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */
        _this.editButtonView = _this._createButton(t('Edit link'), pencilIcon, 'edit');
        /**
     * The value of the "href" attribute of the link to use in the {@link #previewButtonView}.
     *
     * @observable
     * @member {String}
     */
        _this.set('href');
        /**
     * A collection of views that can be focused in the view.
     *
     * @readonly
     * @protected
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this._focusables = new ViewCollection();
        /**
     * Helps cycling over {@link #_focusables} in the view.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */
        _this._focusCycler = new FocusCycler({
            focusables: _this._focusables,
            focusTracker: _this.focusTracker,
            keystrokeHandler: _this.keystrokes,
            actions: {
                // Navigate fields backwards using the Shift + Tab keystroke.
                focusPrevious: 'shift + tab',
                // Navigate fields forwards using the Tab key.
                focusNext: 'tab'
            }
        });
        _this.setTemplate({
            tag: 'div',
            attributes: {
                'class': [
                    'ck',
                    'ck-link-actions'
                ],
                // https://github.com/ckeditor/ckeditor5-link/issues/90
                tabindex: '-1'
            },
            children: [
                _this.previewButtonView,
                _this.editButtonView,
                _this.unlinkButtonView
            ]
        });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(LinkActionsView, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(LinkActionsView.prototype), 'render', this).call(this);
                var childViews = [
                    this.previewButtonView,
                    this.editButtonView,
                    this.unlinkButtonView
                ];
                childViews.forEach(function (v) {
                    // Register the view as focusable.
                    _this2._focusables.add(v);
                    // Register the view in the focus tracker.
                    _this2.focusTracker.add(v.element);
                });
                // Start listening for the keystrokes coming from #element.
                this.keystrokes.listenTo(this.element);
            }    /**
     * Focuses the fist {@link #_focusables} in the actions.
     */
        },
        {
            key: 'focus',
            value: function focus() {
                this._focusCycler.focusFirst();
            }    /**
     * Creates a button view.
     *
     * @private
     * @param {String} label The button label.
     * @param {String} icon The button icon.
     * @param {String} [eventName] An event name that the `ButtonView#execute` event will be delegated to.
     * @returns {module:ui/button/buttonview~ButtonView} The button view instance.
     */
        },
        {
            key: '_createButton',
            value: function _createButton(label, icon, eventName) {
                var button = new ButtonView(this.locale);
                button.set({
                    label: label,
                    icon: icon,
                    tooltip: true
                });
                button.delegate('execute').to(this, eventName);
                return button;
            }    /**
     * Creates a link href preview button.
     *
     * @private
     * @returns {module:ui/button/buttonview~ButtonView} The button view instance.
     */
        },
        {
            key: '_createPreviewButton',
            value: function _createPreviewButton() {
                var button = new ButtonView(this.locale);
                var bind = this.bindTemplate;
                var t = this.t;
                button.set({
                    withText: true,
                    tooltip: t('Open link in new tab')
                });
                button.extendTemplate({
                    attributes: {
                        'class': [
                            'ck',
                            'ck-link-actions__preview'
                        ],
                        href: bind.to('href', function (href) {
                            return href && ensureSafeUrl(href);
                        }),
                        target: '_blank'
                    }
                });
                button.bind('label').to(this, 'href', function (href) {
                    return href || t('This link has no URL');
                });
                button.bind('isEnabled').to(this, 'href', function (href) {
                    return !!href;
                });
                button.template.tag = 'a';
                button.template.eventListeners = {};
                return button;
            }
        }
    ]);
    return LinkActionsView;
}(View);
/**
 * Fired when the {@link #editButtonView} is clicked.
 *
 * @event edit
 */
/**
 * Fired when the {@link #unlinkButtonView} is clicked.
 *
 * @event unlink
 */
export {
    LinkActionsView as default
};